import React from 'react';
import TagManager from 'react-gtm-module'

// import Footer from './components/footer';
// import { Link, withRouter } from 'react-router-dom';
//Redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Product from './components/MainPageProduct';
import FeaturedProduct from "./components/FeaturedProduct"
import PopularProduct from "./components/PopularProduct"
import ExploreProduct from "./components/ExploreProduct"

import * as actionCreators from './store/actions';
import { Container, Row, Image } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import ReactLoading from 'react-loading';
import $ from 'jquery';

import isStringArabic from './store/isStringArabic';
import CartMenu from './components/CartMenu';
import Category from './components/Category';


// IMAGES
import SubscribedNavbar from './components/SubscribedNavbar';
import SubscribedFooter from './components/SubscribedFooter';


// import ScrollContainer from 'react-indiana-drag-scroll'
const rulesList = [
	{
		id: 1,
		text: "فيديو جديد بصوتك لمدة دقيقة"
	},
	{
		id: 2,
		text: " @ShaheenMusic فولو و منشن حساب "

	},
	{
		id: 3,
		text: " @ShaheenMusic متابعة حسابات "

	}
]
class Home extends React.Component {
	state = {
		showPowerText: false,
		menuExpaned: null,
		bucketExpaned: null
	}
	UNSAFE_componentWillMount() {
		const tagManagerArgs = {
			gtmId: 'GTM-N9VH3SG',
			auth: "L30oIK794waeC2pZS76yUw",
			preview: "env-3",
			
		}
		TagManager.initialize(tagManagerArgs)
	}
	componentDidMount() {
		// setTimeout(() => {
		// 	this.setState({
		// 		showPowerText: true
		// 	})
		// }, 3000)
		this.props.setUserLocation()
		const { pathname } = this.props.location;

		// this.props.getLanguageListPOEdit(pathname === "/ar" ? "ar" : "en")
		this.props.getLanguageListPOEdit(pathname === "/clientwebsite2/ar" ? "ar" : "en")

		this.props.savePathName(pathname)
		if (isEmpty(this.props.instagramAccountInfo.brandName))
			this.props.getInstagramAccountDetail(this.props.history);

		this.props.myCartList()
	}
	componentDidUpdate(prevProps) {
		if (
			!isNull(this.props.instagramAccountInfo.snap_pixel_script) &&
			!isEmpty(this.props.instagramAccountInfo.snap_pixel_script) &&
			prevProps.instagramAccountInfo.snap_pixel_script !== this.props.instagramAccountInfo.snap_pixel_script
		) {
			const tagManagerArgs = {
				gtmId: 'GTM-N9VH3SG',
				auth: "L30oIK794waeC2pZS76yUw",
				preview: "env-3",
				
			}
 
			TagManager.initialize(tagManagerArgs)


			var embedCode = this.props.instagramAccountInfo.snap_pixel_script; // <script>//my js script code</script>
			$('head').append(embedCode);
		}
		if (prevProps.explore_products !== this.props.explore_products) {
			  const {currency} = this.props
			window.dataLayer.push({
				'ecommerce': {
					'currencyCode': currency,                       // Local currency is optional.
					'impressions': this.props.explore_products && this.props.explore_products.length > 0 ?
									this.props.explore_products.map(item => {
										const price = item.prices &&  
												item.prices.length > 0 &&
												item.prices.find(pr => pr.currency === currency)
										return {
											id: item.id,
											name: item.name,
											price: price ? parseFloat(price.price): '',
											list: "Explore Products"
										}
									}
									):[]
				}
			});
			// window.dataLayer.push({
			// 	'event': 'view_item_list',
			// 	'ecommerce': {
			// 		'items': this.props.explore_products && this.props.explore_products.length > 0 ?
			// 			this.props.explore_products.map(item => {
			// 				const price = item.prices &&  
      //             item.prices.length > 0 &&
      //             item.prices.find(pr => pr.currency === currency)
			// 				return {
			// 					item_id: item.id,
			// 					item_name: item.name,
			// 					item_unit_price: price ? parseFloat(price.price): '',
			// 					currency: currency
			// 				}
			// 			}
			// 			):[]
			// 		}
			// })
		}
	}
	errorLoadingPicture = (error) => {
		const { businessid, insta_handle } = this.props.instagramAccountInfo
		this.props.updateBusinessLogo(businessid, insta_handle)
	}
	changeLanguage = () => {
		if (this.props.language === "en") {
			// this.props.history.replace("/ar")
			this.props.history.replace("/clientwebsite2/ar")

		} else {
			this.props.history.replace("/")
		}
	}
	closeCartMenu = () => {
		this.setState({
			bucketExpaned: false
		})
	}
	expandBucket = () => {
		this.setState({
			bucketExpaned: true
		})
	}
	render() {
		const translate = this.props.translate
		document.body.classList.remove('inner-page');

		// console.log('this.props.instagramAccountInfo', this.props.instagramAccountInfo);
		// console.log(' this.props.pathname', this.props.pathname);

		if (this.props.loadingInstaDetail) {
			return (
				<div className="outerDiv">
					<ReactLoading type="spin" color="#FF9D00" />
				</div>
			);
		}
		return (
			<div className="outerDiv">
				{/* <div className={`topNavBar ${this.props.language === "ar" && "topNavBarRTL"}`}
					style={{
						filter: window.innerWidth <= 991 && (this.state.menuExpaned || this.state.bucketExpaned) ? "blur(5px)" : "none"
					}}
				>

					<Row className="brandImageRow">
						<Image className="brandImage" src={this.props.instagramAccountInfo.brandProfilePic} onError={this.errorLoadingPicture} />
					</Row>
					<Row
						className="brandNameText"
						style={{
							fontFamily: isStringArabic(this.props.instagramAccountInfo.brandName)
								? 'Changa-bold'
								: 'Montserrat-bold',
						}}
					>
						{this.props.instagramAccountInfo.brandName}
					</Row>
				
					<p onClick={this.changeLanguage} className={`languageButton ${this.props.language === "en" && "arabic"} ${this.props.language === "ar" && " languageButtonRTL"}`} >
						{this.props.language === "en" ? "العربية" : "English"}
					</p>
				</div>
				 */}
				<SubscribedNavbar
					categories={this.props.categories}
					expandBucket={this.expandBucket}
					translate={this.props.translate}
					cartList={this.props.cartList}
					instagramAccountInfo={this.props.instagramAccountInfo}
					language={this.props.language}
					history={this.props.history}
				/>

				<CartMenu
					currency={this.props.currency}
					translate={this.props.translate}
					cartList={this.props.cartList}
					closeCartMenu={this.closeCartMenu}
					bucketExpaned={this.state.bucketExpaned}
				/>
				{
					this.props.instagramAccountInfo.businessName !== "shaheenmusic" &&
					<div className={"mainBodyOuterDiv"} style={{
						filter: window.innerWidth <= 1024 && (this.state.menuExpaned || this.state.bucketExpaned) ? "blur(5px)" : "none"
					}}
						onClick={() => {
							if (this.state.menuExpaned) {
								this.setState({
									menuExpaned: false
								})
							}
							if (this.state.bucketExpaned) {
								this.setState({
									bucketExpaned: false
								})
							}
						}}
					>


						{this.props.featuredProductsList && this.props.featuredProductsList.length > 0 &&
							<div style={{
								width: '100%', display: "flex",
								justifyContent: "center"
							}}>
								<FeaturedProduct
									featuredProductsList={this.props.featuredProductsList}
									businessName={this.props.instagramAccountInfo.businessName}
									whatsappLink={this.props.instagramAccountInfo.whatsappLink}

								/>
							</div>
						}
						{this.props.popularProductsList && this.props.popularProductsList.length > 0 &&
							<div >
								<h4 className={`headingText ${this.props.language === "ar" && "headingTextRTL"} `} style={{ fontFamily: isStringArabic(translate[this.props.instagramAccountInfo.web_heading_key_name]) ? "Changa-bold" : "Montserrat-bold" }}>
									{translate['Popular Items']}
								</h4>
								<Container className="popularProductContainer" dir={this.props.language === "ar" ? "rtl" : "ltr"}>

									{this.props.popularProductsList.map(product => (
										<PopularProduct
											key={product.id}
											media={product}
											businessName={this.props.instagramAccountInfo.businessName}
											whatsappLink={this.props.instagramAccountInfo.whatsappLink}
											currency={this.props.currency}
											translate={this.props.translate}
											language={this.props.language}
										/>
									))}

								</Container>
							</div>
						}
						{this.props.categories && this.props.categories.length > 0 &&
							<div style={{ width: '100%' }} >
								<h4 className={`headingText ${this.props.language === "ar" && "headingTextRTL"} `} style={{ fontFamily: isStringArabic(translate[this.props.instagramAccountInfo.web_heading_key_name]) ? "Changa-bold" : "Montserrat-bold" }}>
									SHOP BY CATEGORY
								</h4>
								<Container className="productsListContainer">
									<Row className="productsListRow">
										{this.props.categories.map(product => (
											<Category
												key={product.id}
												media={product}
												businessName={this.props.instagramAccountInfo.businessName}
												whatsappLink={this.props.instagramAccountInfo.whatsappLink}
												currency={this.props.currency}
												translate={this.props.translate}
												language={this.props.language}
											/>
										))}

									</Row>
								</Container>
							</div>
						}
						{this.props.categories && this.props.categories.length === 0 && this.props.explore_products && this.props.explore_products.length > 0 &&
							<div style={{ width: '100%' }} >
								<h4 className={`headingText ${this.props.language === "ar" && "headingTextRTL"} `} style={{ fontFamily: isStringArabic(translate[this.props.instagramAccountInfo.web_heading_key_name]) ? "Changa-bold" : "Montserrat-bold" }}>
									{translate[this.props.instagramAccountInfo.web_heading_key_name]}
								</h4>
								<Container className="productsListContainer">
									<Row className="productsListRow">
										{this.props.explore_products.map(product => (
											<ExploreProduct
												key={product.id}
												media={product}
												businessName={this.props.instagramAccountInfo.businessName}
												whatsappLink={this.props.instagramAccountInfo.whatsappLink}
												currency={this.props.currency}
												translate={this.props.translate}
												language={this.props.language}
											/>
										))}

									</Row>
								</Container>
							</div>
						}
						{(((!this.props.explore_products || (this.props.explore_products && this.props.explore_products.length === 0))
							&& this.props.instagramAccountInfo.imagesList && this.props.instagramAccountInfo.imagesList.length > 0))
							&& (
								<div >
									<h4 className={`headingText ${this.props.language === "ar" && "headingTextRTL"} `} style={{ fontFamily: isStringArabic(translate[this.props.instagramAccountInfo.web_heading_key_name]) ? "Changa-bold" : "Montserrat-bold" }}>
										{translate[this.props.instagramAccountInfo.web_heading_key_name]}
									</h4>
									<Container className="productsListContainer">
										<Row className="productsListRow">
											{this.props.instagramAccountInfo.imagesList &&
												this.props.instagramAccountInfo.imagesList.map(image => (
													<Product
														key={image.imageId}
														media={image}
														businessName={this.props.instagramAccountInfo.businessName}
														whatsappLink={this.props.instagramAccountInfo.whatsappLink}
													/>
												))}
										</Row>
									</Container>
								</div>
							)}
						{/* To show view more button when loading images from instagram */}
						{((!this.props.explore_products || (this.props.explore_products && this.props.explore_products.length === 0)) && (this.props.instagramAccountInfo.end_cursor && this.props.instagramAccountInfo.hasNextPage)
							&& (this.props.instagramAccountInfo.imagesList.length < this.props.no_of_products_to_show)) && (
								<div style={{
									display: "flex",
									alignSelf: "center",
									// background: "#f4f4f4",
									background: "#F8F8F8",
									justifyContent: "center",
									marginTop: -1,
									marginBottom: -1,
									paddingTop: 1,
									paddingBottom: 1,


								}}>
									<button
										style={{
											cursor: "pointer",
											alignSelf: "center",
											background: "transparent",
											border: "1px solid #ff790a",
											borderRadius: 50,
											color: "#ff790a",
											height: 40,
											width: 200,
											fontFamily: isStringArabic(translate[this.props.instagramAccountInfo.viewMore]) ? "changa-bold" : "montserrat-bold"

										}}
										onClick={() => this.props.loadMoreInstagramPost(this.props.instagramAccountInfo.id, this.props.instagramAccountInfo.end_cursor)}
									>
										{translate[this.props.instagramAccountInfo.viewMore]}
									</button>
								</div>
							)}

					</div>

				}
				{/* {
					this.props.instagramAccountInfo.businessName !== "shaheenmusic" && this.props.instagramAccountInfo.imagesList && this.props.instagramAccountInfo.imagesList.length > 0 && (
						<div style={{ width: '100%' }}>
							<div className="shopNowContainer">
								<h4 style={{ fontFamily: isStringArabic(translate[this.props.instagramAccountInfo.web_heading_key_name]) ? "Changa-bold" : "Montserrat-bold" }}>
									{translate[this.props.instagramAccountInfo.web_heading_key_name]}
								</h4>
							</div>
							<Container className="productsListContainer">
								<Row className="productsListRow">
									{this.props.instagramAccountInfo.imagesList &&
										this.props.instagramAccountInfo.imagesList.map(image => (
											<Product
												key={image.imageId}
												media={image}
												businessName={this.props.instagramAccountInfo.businessName}
												whatsappLink={this.props.instagramAccountInfo.whatsappLink}
											/>
										))}
								</Row>
							</Container>
							To show view more button when loading images from instagram
							{((this.props.instagramAccountInfo.end_cursor && this.props.instagramAccountInfo.hasNextPage)
								&& (this.props.instagramAccountInfo.imagesList.length < this.props.no_of_products_to_show)) && (
									<div style={{
										display: "flex",
										alignSelf: "center",
										background: "#f4f4f4",
										justifyContent: "center",
										marginTop: -1,
										marginBottom: -1,
										paddingTop: 1,
										paddingBottom: 1,


									}}>
										<button
											style={{
												cursor: "pointer",
												alignSelf: "center",
												background: "transparent",
												border: "1px solid #ff790a",
												borderRadius: 50,
												color: "#ff790a",
												height: 40,
												width: 200,
												fontFamily: isStringArabic(translate[this.props.instagramAccountInfo.viewMore]) ? "changa-bold" : "montserrat-bold"

											}}
											onClick={() => this.props.loadMoreInstagramPost(this.props.instagramAccountInfo.id, this.props.instagramAccountInfo.end_cursor)}
										>
											{translate[this.props.instagramAccountInfo.viewMore]}
										</button>
									</div>
								)}

						</div>
					)
				} */}


				{/* For shaheen music client  */}


				{
					this.props.instagramAccountInfo.businessName === "shaheenmusic" &&
					<div style={{ width: '100%' }}>
						<div className="shopNowContainer">
							<h4 style={{ fontFamily: isStringArabic(this.props.instagramAccountInfo.web_heading_key_name) ? "Changa-bold" : "Montserrat-bold" }}>
								{/* {this.props.instagramAccountInfo.web_heading_key_name} */}
							</h4>
						</div>
						<Container className="productsListContainer comptitionDiv">

							<h4 className="shaheenmusicHeadText">
								جوائز بقيمة
							</h4>
							<h4 className="shaheenmusicPriceText">
								5000 <span className="shaheenmusicPriceSpanText">SAR</span>
							</h4>
							<h4 className="shaheenmusicRulesText">
								!و انتاج عمل فني
							</h4>
							<h5 className="rulesText">
								:شروط المسابقة
							</h5>
							<div className="divRulesOuter">
								{rulesList.map(rule =>
									<div className="ruleDiv">
										<p className="ruleNumber">
											{rule.id}
										</p>
										<p className="ruleListText">
											{rule.text}
										</p>
									</div>
								)}
							</div>
							<button
								variant="secondary"
								// disabled={this.props.loadingInstaDetail || !this.props.productDetail.shortcode || !this.props.productDetail.imageId}
								className="orderButton musicInstaButtonorder "
								id={'shopnow'}
								onClick={() => {
									// if (isMobile) {
									// 	window.open(this.props.instagramAccountInfo.instagramLink)
									// } else {
									window.open(`https://www.instagram.com/${this.props.instagramAccountInfo.insta_handle}`)
									// }
								}}
								style={{
									fontFamily: isStringArabic(this.props.instagramAccountInfo.button_text) ? "Changa-bold" : "Montserrat-bold"
								}}
							>
								{this.props.instagramAccountInfo.button_text}
								<Image
									className="musicInstaButton"
									src={`/assets/images/svgs/${this.props.instagramAccountInfo.button_icon}.svg`}
								/>
							</button>
						</Container>


					</div>

				}


				{/*Footer Component*/}
				<SubscribedFooter
					pathname={this.props.pathname}
					translate={this.props.translate}
					instagramAccountInfo={this.props.instagramAccountInfo}
				/>

				{/*tap-top*/}
				{/* <div className="tap-top">
					<div>
						<i className="fa fa-angle-up" aria-hidden="true" />
					</div>
				</div> */}
			</div >
		);
	}
}
const mapDispatchToProps = dispatch => ({
	getInstagramAccountDetail: history => dispatch(actionCreators.getInstagramAccountDetail(history)),
	loadMoreInstagramPost: (instaHandleId, instaEndCursor) => dispatch(actionCreators.loadMoreInstagramPost(instaHandleId, instaEndCursor)),
	savePathName: pathname => dispatch(actionCreators.savePathName(pathname)),
	updateBusinessLogo: (businessid, insta_handle) => dispatch(actionCreators.updateBusinessLogo(businessid, insta_handle)),
	getLanguageListPOEdit: (language) => dispatch(actionCreators.getLanguageListPOEdit(language)),
	setUserLocation: () => dispatch(actionCreators.setUserLocation()),
	myCartList: () => dispatch(actionCreators.myCartList()),
});
const mapStateToProps = state => ({
	language: state.websiteLanguage.language,
	instagramAccountInfo: state.campaign.instagramAccountInfo,
	errorMessage: state.campaign.errorMessage,
	loadingInstaDetail: state.campaign.loadingInstaDetail,
	no_of_products_to_show: state.campaign.no_of_products_to_show,
	pathname: state.login.pathname,
	translate: state.websiteLanguage.translations,
	featuredProductsList: state.campaign.featuredProductsList,
	popularProductsList: state.campaign.popularProductsList,
	explore_products: state.campaign.explore_products,
	currency: state.login.currency,
	cartList: state.cart.cartList,
	categories: state.campaign.categories
});
export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Home)
);



// WEBPACK FOOTER //
// ./src/home.js